import { DrawApi } from '@apply/api';
import { DrawType } from '@apply/constants';

import React from 'react';

interface ICancelButtonProps {
    draw: DrawApi.IDraw;
    onDrawDeleted: (id: number) => void;
}

export const CancelButton = ({ draw, onDrawDeleted }: ICancelButtonProps): JSX.Element => {
    if ((draw.borrowerSubmitted && !draw.needsBorrowerSignature) || draw.drawType !== DrawType.Manual || draw.isFinalized)
        return <></>;

    return (
        <button
            onClick={() => onDrawDeleted(draw.id)}
            title='Cancel and delete Draw.'
            className='button primary'
        >
            Cancel
        </button>
    );
};
